import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
// import { PdfMakeService, dataPdfMake, dataLogPdf } from 'src/app/directives/pdfmake.config';
import { APP } from 'src/app/constants';
import { EmpresaService } from '@app/services/empresa.service';
import { AuthService } from '@app/services/auth.service';

@Component({
	selector: 'app-navbar',
	templateUrl: './navbar.component.html',
	styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
	public dataUser: any = {};
	public Empr_name: string = '';
	public address: string = '';
	public phone: string = '';
	public ciudad: string = '';

	dataUsuario = null;

	constructor(
		private _ToastrService: ToastrService,
		private _LocalStorageService: LocalStorageService,
		private _Router: Router,
		// private pdfMakeService: PdfMakeService,
		private _AuthService: AuthService,
		private _EmpresaService: EmpresaService

	) { }

	ngOnInit() {
		this.cargarDataUsuario();
	}

	cargarDataUsuario() {
		this._AuthService.cargarDataUsuario({}, (data) => {
			this.dataUsuario = data.decodeToken.sub;
			this.dataUser.nombre_p = this.dataUsuario.nombre;
			this.dataUser.nombre = this.dataUsuario.primer_nombre + ' ' + this.dataUsuario.primer_apellido;
			this.dataUser.usuario = this.dataUsuario.usuario;
			this.cargarEmpresa();
		});
	}

	cargarEmpresa(){
		this._EmpresaService.listarEmpresa({id_empresa: this.dataUsuario.id_empresa}, (data)=>{
			this.Empr_name = data.filas.recordset[0].razemp;
			this.address = data.filas.recordset[0].diremp;
			this.ciudad = data.filas.recordset[0].ciualm;
			this.phone = data.filas.recordset[0].telemp;	
		})
	}

	logout() {
		swal({
			title: '¿Seguro que desea cerrar sesion?',
			text: '',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Si, estoy de acuerdo',
			cancelButtonText: 'No',
			confirmButtonClass: 'btn btn-primary',
			cancelButtonClass: 'btn btn-default',
			reverseButtons: true
		}).then((result) => {
			if (result.value) {
				this._ToastrService.success('Vuelve pronto', 'Sesion terminada');
				this._LocalStorageService.set('tokenUserActive', null);
				this._Router.navigate(['login']);
			}
		});
	}
}
